import React, { Component, Fragment } from "react";
import "./App.css";
import "./Enlyte.css";
import { Header, Footer } from "./Components/Layouts";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import ProviderHome from "./Components/Pages/ProviderHome";
import Notifications from "./Components/Pages/Notifications";
import AuthenticatedRoute from "./Components/AuthenticatedRoute";
import LoginComponent from "./Components/LoginComponent";
import LogoutComponent from "./Components/LogoutComponent";
import MainMenu from "./Components/MainMenu/MainMenu";
import ClientList from "./Components/Pages/ClientList";
import BillSearch from "./Components/Pages/BillSearch/BillSearch";
import ManageUsers from "./Components/Pages/ManageUsers";
import ClaimSearch from "./Components/Pages/ClaimSearch";
import ManageTins from "./Components/Pages/ManageTins";
import News from "./Components/Pages/News";
import { RequestAccount } from "./Components/Pages/RequestAccount";
import { EmailRegistration } from "./Components/Pages/RequestAccount/EmailRegistration";
import ResetPassword from "./Components/Pages/ResetPassword/ResetPassword";
import ConfirmPasswordReset from "./Components/Pages/ResetPassword/ConfirmPasswordReset";
import UserProfile from "./Components/Pages/UserProfile";
import EditProfile from "./Components/Pages/EditProfile";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "./AetnaTheme.js";
import ManageTinsForUser from "./Components/Pages/ManageTinsForUser";
import ViewTinsForUser from "./Components/Pages/ViewTinsForUser";
import ManageTINsforNNUS from "./Components/Pages/ManageTINsforNNUS";
import ForgotUsername from "./Components/ForgotUsername";
import AddUser from "./Components/Pages/AddUser";
import ManageUserAddUser from "./Components/Pages/ManageUserAddUser";
import AddUserManageTin from "./Components/Pages/AddUserManageTin";
import ConfirmAddUser from "./Components/Pages/ConfirmAddUser";
import ProviderResources from "./Components/Pages/ProviderResources";
import AuthenticationService from "./Services/AuthenticationService";
import PageNotFound from "./Components/Pages/PageNotFound";
import LoginHeader from "./Components/Layouts/LoginHeader";
import UserSearch from "./Components/Pages/UserSearch";
import ProviderSearch from "./Components/Pages/ProviderSearch";
import FeeSchedule from "./Components/Pages/FeeSchedule/FeeSchedule";
import ChangePassword from "./Components/Pages/ChangePassword";
import EmailDomains from "./Components/Pages/EmailDomains/EmailDomains";
import ManageRecipients from "./Components/Pages/ManageRecipients";
import DemographicSearch from "./Components/Pages/Demographics/DemographicSearch";
import { UserAccountNotes } from "./Components/Pages/UserAccountNotes";

import AddUserManageTinsPermissionChecker from "./utils/Security/AddUserManageTinsPermissionChecker";
import AddUserPermissionChecker from "./utils/Security/AddUserPermissionChecker";
import BillSearchPermissionChecker from "./utils/Security/BillSearchPermissionChecker";
import ClaimSearchPermissionChecker from "./utils/Security/ClaimSearchPermissionChecker";
import ClientListPermissionChecker from "./utils/Security/ClientListPermissionChecker";
import EditProfilePermissionChecker from "./utils/Security/EditProfilePermissionChecker";
import ManageTinsForUserPermissionChecker from "./utils/Security/ManageTinsForUserPermissionChecker";
import ManageTinsPermissionChecker from "./utils/Security/ManageTinsPermissionChecker";
import ManageUsersAddUserPermissionChecker from "./utils/Security/ManageUsersAddUserPermissionChecker";
import ManageUsersPermissionChecker from "./utils/Security/ManageUsersPermissionChecker";
import ManageRostersPermissionChecker from "./utils/Security/ManageRostersPermissionChecker";
import ManageGroupsPermissionChecker from "./utils/Security/ManageGroupsPermissionChecker";
import NotificationsPermissionChecker from "./utils/Security/NotificationsPermissionChecker";
import DemographicSearchPermissionChecker from "./utils/Security/DemographicSearchPermissionChecker";
import ProviderResourcesPermissionChecker from "./utils/Security/ProviderResourcesPermissionChecker";
import UserSearchPermissionChecker from "./utils/Security/UserSearchPermissionChecker";
import ProviderSearchPermissionChecker from "./utils/Security/ProviderSearchPermissionChecker";
import ViewTinsForUserPermissionChecker from "./utils/Security/ViewTinsForUserPermissionChecker";
import HomePermissionChecker from "./utils/Security/HomePermissionChecker";
import UserProfilePermissionChecker from "./utils/Security/UserProfilePermissionChecker";
import ChangePasswordPermissionChecker from "./utils/Security/ChangePasswordPermissionChecker";
import DomainRestrictionPermissionChecker from "./utils/Security/DomainRestrictionPermissionChecker";
import RegistrationComplete from "./Components/Pages/Registration/RegistrationComplete";
import LoginCache from "./Components/LoginCache";
import HeapPageTracker from "./Components/HeapPageTracker";
import ManageRosters from "./Components/Pages/ManageRosters/ManageRosters";
import ManageGroups from "./Components/Pages/ManageGroups/ManageGroups";
import ManageRosterSourcesForUserGroup from "./Components/Pages/ManageRosterSourcesForUserGroup";

class App extends Component {
  timeout;

  getUserState = (user) => ({
    user: user,
    isSubUser: user ? user.typeCd === "PRUS" : true,
    typeCd: user ? user.typeCd : "",
    adminUser: user ? user.typeCd === "ISAD" || user.typeCd === "IRAD" : false,
    feeSchedRqstCount: user ? user.feeSchedRqstsCnt : undefined,
    feeSchedRqstFiles: user ? user.feeSchedRqsts : [],
  });

  scheduleUserSetup = (user) => {
    if (!user) {
      return;
    }

    this.clearUserSetupTimers();
    this.idleTimeOutSetupTimer = setTimeout(() => this.getIdleTimeOut(), 5000);
    this.walkMeSetupTimer = setTimeout(() => this.startWalkMe(user), 2000);
  };

  clearUserSetupTimers = () => {
    if (this.idleTimeOutSetupTimer) {
      clearTimeout(this.idleTimeOutSetupTimer);
      this.idleTimeOutSetupTimer = null;
    }

    if (this.walkMeSetupTimer) {
      clearTimeout(this.walkMeSetupTimer);
      this.walkMeSetupTimer = null;
    }
  };

  constructor(props) {
    super(props);
    var user = AuthenticationService.reregisterLoginUser();
    var mirrorUser = AuthenticationService.getMirrorUserInfo();
    if (user) {
      window.chatUser = user;
    }

    var mirrorUserNm = null;
    if (mirrorUser) {
      mirrorUserNm = `Mirroring (${mirrorUser.userFirstName} ${mirrorUser.userLastName}) `;
    }

    this.state = {
      isScrollTop: false,
      isChangedPwd: false,
      logout: false,
      isTimeOut: false,
      ...this.getUserState(user),
      mirrorUser: mirrorUser,
      mirrorUserNm: mirrorUser ? mirrorUser.userNm : "",
      mirrorUsrNmDisplay: mirrorUserNm ? mirrorUserNm : "",
      mirrorUserTypeCd: mirrorUser?.typeCd,
      mirrorUserAffiliationCd: mirrorUser?.affiliationCd,
    };    
  }

  startWalkMe = (user) => {
    try {
      var walkMeDiv = document.getElementById('walkMeDiv')
      if ( !walkMeDiv ) {
        if ( !window.analytics || !window.analytics.user ) {
          AuthenticationService.setUserDetails(user)
        }

        walkMeDiv = document.createElement("div");
        walkMeDiv.id="walkMeDiv";
        document.body.appendChild(walkMeDiv);
        var walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = window.walkMeUrl;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = {smartLoad:true};  
        this.walkMeLoaded = true;     
      } 
    } catch (e) {
       console.log(e, e);
    }
  }

  // currently called from the UserProfileDlg so main menu is updated based on the new
  // user properties
  updateUser = (user) => {
    this.setState({ user: user });
  };

  scrollToTop = () => {
    this.setState({ isScrollTop: true });
  };

  setChangedPwd = (changed) => {
    this.setState({ isChangedPwd: changed });
  };

  setUser = (user) => {
    window.chatUser = user;

    this.setState({
      ...this.getUserState(user),
    });
    this.scheduleUserSetup(user);
  };

  setFeeSchedRqstCount = (count) => {
    this.setState({ feeSchedRqstCount: count });
  };

  setFeeSchedRqstsFiles = (feeSchedRqsts) => {
    this.setState({ feeSchedRqstFiles: feeSchedRqsts });
  };

  componentDidMount() {
    this.setChangedPwd(false);
    this.events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];
    this.removeListeners();
    this.scheduleUserSetup(this.state.user);
  }

  componentWillUnmount() {
    this.removeListeners();
    this.clearTimeoutFunc();
    this.clearUserSetupTimers();
  }

  removeListeners = () => {
    for (let i in this.events) {
      window.removeEventListener(this.events[i], this.resetTimeout);
    }
  };

  componentDidUpdate() {
    if (this.state.isScrollTop) {
      window.scrollTo(0, 0);
      this.setState({ isScrollTop: false });
    }
  }

  getIdleTimeOut = () => {
    AuthenticationService.getIdleTimeout()
      .then((response) => {
        this.setIdleTime(response.data);
      })
      .catch((error) => {
        this.setIdleTime(30);
        console.log("Get idle timeout error:" + error);
      });
  };

  setIdleTime = (idleTime) => {
    //   console.log(`start time ${new Date().toLocaleTimeString()} for time out of ${idleTime}`)
    this.timeout = idleTime * 60000;
    for (let i in this.events) {
      window.addEventListener(this.events[i], this.resetTimeout);
    }
    this.setTimeout();
  };

  clearTimeoutFunc = () => {
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  };

  setLogout = () => {
    this.stopMirror();
    if (this.state.logout === true) {
      this.setState({ logout: false, isTimeOut: true, user: null });
    } else {
      this.setState({ user: null });
    }
    this.clearTimeoutFunc();
  };

  setTimeout = () => {
    this.logoutTimeout = setTimeout(this.logout, this.timeout);
  };
  resetTimeout = () => {
    //   console.log(`reset time out time ${new Date().toLocaleTimeString()} for time out of ${this.state.signOutTime/60000}`)
    this.clearTimeoutFunc();
    this.setTimeout();
  };

  logout = () => {
    this.removeListeners();
    this.clearTimeoutFunc();
    this.setState({ logout: true });
    //  console.log(`logged out time ${new Date().toLocaleTimeString()} for time out of ${this.state.signOutTime}`)
  };

  timeOut = () => {
    const timeout = this.state.isTimeOut;
    this.setState({ isTimeOut: false });
    return timeout;
  };

  showMenu = () => {
    if (this.state.user !== null) {
      AuthenticationService.getIdleTimeout();
      return (
        <AuthenticatedRoute
          user={this.state.user}
          path="/*"
          render={(props) => (
            <MainMenu
              {...props}
              user={this.state.user}
              isSubUser={this.state.isSubUser}
              mirrorUser={this.state.mirrorUser}
              typeCd={this.state.typeCd}
              mirrorUserTypeCd={this.state.mirrorUserTypeCd}
              isAdminPortal={this.state.adminUser}
              isMirror={this.state.mirrorUserNm !== ""}
            />
          )}
        />
      );
    }
  };

  showHeader = () => {
    if (this.state.user === null) {
      return <Route path="/*" exact component={LoginHeader} />;
    } else {
      return (
        <Route
          path="/*"
          render={(props) => (
            <Header
              {...props}
              updateUser={this.updateUser}
              user={this.state.user}
              mirrorUserNm={this.state.mirrorUserNm}
              mirrorUsrNmDisplay={this.state.mirrorUsrNmDisplay}
              setLogout={this.setLogout}
              setMirror={this.setMirror}
              stopMirror={this.stopMirror}
              logout={this.state.logout}
              feeSchedRqstCount={this.state.feeSchedRqstCount}
              setFeeSchedRqstCount={this.setFeeSchedRqstCount}
              feeSchedRqstFiles={this.state.feeSchedRqstFiles}
              setFeeSchedRqstsFiles={this.setFeeSchedRqstsFiles}
            />
          )}
        />
      );
    }
  };

  stopMirror = () => {
    if (this.state.mirrorUserNm === "") {
      AuthenticationService.removeMirrorUser();
    } else {
      if (this.state.user) {
        AuthenticationService.removeMirrorUser(
          this.state.mirrorUserNm,
          `${this.state.user?.userFirstName} ${this.state.user?.userLastName}`
        );
      }
      this.setState({ feeSchedRqstCount: null, feeSchedRqstFiles: null });
    }

    this.setState({
      mirrorUser: null,
      mirrorUserNm: "",
      mirrorUsrNmDisplay: "",
    });
  };

  setMirrorUsrNotifications = (mirrorUser) => {
    AuthenticationService.getUsrDtls(mirrorUser)
      .then((response) => {
        this.setState({
          feeSchedRqstCount: response.data.feeSchedRqstsCnt,
          feeSchedRqstFiles: response.data.feeSchedRqsts,
        });
      })
      .catch(function (error) {
        console.log("Mirror user, get user error:" + error);
      });
  };

  setMirror = (mirrorUserNm, mirrorUser) => {
    this.setMirrorUsrNotifications(mirrorUser.userNm);

    AuthenticationService.setMirrorUser(mirrorUser.userNm, mirrorUser);
    this.setState({
      mirrorUser: mirrorUser,
      mirrorUserNm: mirrorUser.userNm,
      mirrorUsrNmDisplay: mirrorUserNm,
      mirrorUserTypeCd: mirrorUser.typeCd,
      mirrorUserAffiliationCd: mirrorUser.affiliationCd,
    });
  };

  getCurrentUser = () => {
    return this.props.mirrorUser ?? this.props.user;
  };

  render() {
    return (
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <div className="App" aria-live="polite">
            <Route
              path="/*"
              render={(props) => (
                <LoginCache {...props} setUser={this.setUser} />
              )}
            />
            <Route path="/*" render={(props) => <HeapPageTracker {...props} />} />
            {this.showHeader()}

            <div style={{ height: "100%" }}>
              {this.showMenu()}

              <div className="main">
                <Switch>
                  <Route
                    path="/wcpp/authenticate"
                    exact
                    render={(props) => (
                      <LoginComponent
                        {...props}
                        setUser={this.setUser}
                        setCode={this.setCode}
                      />
                    )}
                  />
                  <Route
                    path="/wcpp/login"
                    exact
                    render={(props) => (
                      <LoginComponent
                        {...props}
                        setUser={this.setUser}
                        timeOut={this.timeOut}
                      />
                    )}
                  />
                  <Route
                    path="/wcpp/requestAccount"
                    exact
                    component={RequestAccount}
                  />
                  <Route
                    path="/wcpp/emailRegistration"
                    exact
                    component={EmailRegistration}
                  />
                  <Route
                    path="/wcpp/forgotusernm"
                    exact
                    component={ForgotUsername}
                  />
                  <Route
                    path="/wcpp/forgotpassword"
                    exact
                    component={ResetPassword}
                  />
                  <Route
                    path="/wcpp/resetPassword"
                    exact
                    component={ResetPassword}
                  />
                  <Route
                    path="/wcpp/confirmPasswordReset"
                    exact
                    component={ConfirmPasswordReset}
                  />
                  <Route
                    path="/wcpp/confirmAddUser"
                    exact
                    component={ConfirmAddUser}
                  />
                  <Route
                    path="/wcpp/registrationComplete"
                    exact
                    component={RegistrationComplete}
                  />{" "}
                  <AuthenticatedRoute
                    path="/wcpp/providerResources"
                    exact
                    permissionChecker={ProviderResourcesPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ProviderResources}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/logout"
                    exact
                    component={LogoutComponent}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/"
                    exact
                    permissionChecker={HomePermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={() => <ProviderHome />}
                  />
                  <AuthenticatedRoute
                    path="/"
                    exact
                    permissionChecker={HomePermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={() => <ProviderHome />}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/home"
                    permissionChecker={HomePermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={() => <ProviderHome />}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/EditProfile"
                    permissionChecker={EditProfilePermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <EditProfile
                        {...props}
                        user={this.state.mirrorUser ?? this.state.user}
                      />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ClientList"
                    permissionChecker={ClientListPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ClientList}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/Notifications"
                    permissionChecker={NotificationsPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <Notifications
                        {...props}
                        userNm={this.state.user.userNm}
                      />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageRecipients"
                    render={(props) => (
                      <ManageRecipients {...props} typeCD={this.state.typeCd} />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/FeeSchedule"
                    render={(props) => (
                      <FeeSchedule
                        {...props}
                        feeschedrqstCount={this.state.feeSchedRqstCount}
                        setFeeSchedRqstCount={this.setFeeSchedRqstCount}
                        setFeeSchedRqstsFiles={this.setFeeSchedRqstsFiles}
                      />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/UserSearch"
                    permissionChecker={UserSearchPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <UserSearch
                        {...props}
                        typeCD={this.state.typeCd}
                        lgUser={this.state.user}
                        setMirror={this.setMirror}
                      />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ProviderSearch"
                    permissionChecker={ProviderSearchPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ProviderSearch}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/billSearch"
                    permissionChecker={BillSearchPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={BillSearch}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/Demographics/DemographicSearch"
                    permissionChecker={DemographicSearchPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={DemographicSearch}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ClaimSearch"
                    permissionChecker={ClaimSearchPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ClaimSearch}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageTins"
                    permissionChecker={ManageTinsPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ManageTins}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageUsers"
                    permissionChecker={ManageUsersPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <ManageUsers {...props} lgUser={this.state.user} />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageRosters"
                    component={ManageRosters}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageGroups"
                    // permissionChecker={ManageGroupsPermissionChecker}
                    // user={this.state.mirrorUser ?? this.state.user}
                    component={ManageGroups}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageTinsForUser"
                    permissionChecker={ManageTinsForUserPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ManageTinsForUser}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ViewTinsForUser"
                    permissionChecker={ViewTinsForUserPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ViewTinsForUser}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageTINsforNNUS"
                    render={(props) => (
                      <ManageTINsforNNUS {...props} isAdmin={this.state.adminUser} />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ChangePassword"
                    permissionChecker={ChangePasswordPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={() => (
                      <div>
                        <ChangePassword
                          isChangedPwd={this.state.isChangedPwd}
                          setChangedPwd={this.setChangedPwd}
                        />
                      </div>
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/UserProfile"
                    component={UserProfile}
                    permissionChecker={UserProfilePermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                  />
                  <AuthenticatedRoute path="/wcpp/News" component={News} />
                  <AuthenticatedRoute
                    path="/wcpp/AddUser"
                    permissionChecker={AddUserPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <AddUser {...props} isAdmin={this.state.adminUser} />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageUserAddUser"
                    permissionChecker={ManageUsersAddUserPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => <ManageUserAddUser {...props} />}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/AddUserManageTin"
                    permissionChecker={AddUserManageTinsPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={AddUserManageTin}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/ManageRosterSourcesForUserGroup"
                    permissionChecker={AddUserPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    component={ManageRosterSourcesForUserGroup}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/EmailDomains"
					permissionChecker={DomainRestrictionPermissionChecker}
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <EmailDomains {...props} user={this.state.mirrorUser ?? this.state.user} />
                    )}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/PageNotFound"
                    component={PageNotFound}
                  />
                  <AuthenticatedRoute
                    path="/wcpp/UserAccountNotes"
                    user={this.state.mirrorUser ?? this.state.user}
                    render={(props) => (
                      <UserAccountNotes
                        {...props}
                        user={this.state.mirrorUser ?? this.state.user}
                      />
                    )}
                  />
                  <AuthenticatedRoute path="*">
                    <Redirect to="/wcpp/PageNotFound" />
                  </AuthenticatedRoute>
                </Switch>
              </div>
            </div>
            <Footer scrollUp={this.scrollToTop} />
          </div>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }
}

export default App;
